import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../context/PlatformAuthContext';
import '../pages/platform/Platform.css';
import { Lock, Mail } from 'lucide-react';
import PasswordInput from '../components/PasswordInput';
import SocialSignIn from '../components/SocialSignIn';
import './AuthPages.css'; // B-68: the shared Google button styles

export default function PlatformLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const expired = !!location.state?.expired; // W-10: sent here by SessionExpiryRedirect
  const { login, googleSignIn, loading } = usePlatformAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      navigate('/marakin-admin');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="platform-login-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="platform-login-container">
      <div className="platform-login-card">
        <div className="platform-login-header">
          <img src="/marakin-logo-charcoal.png" alt="Marakin" style={{ height: 40, marginBottom: 16 }} />
          <h1 style={{ color: '#48BB78' }}>Admin Portal</h1>
          <p>Platform Management</p>
        </div>

        {/* B-68: your @marakin.co.uk Google account; the server refuses
            any other account before signing anyone in. */}
        <SocialSignIn
          only={['google']}
          signIn={googleSignIn}
          onSignedIn={() => navigate('/marakin-admin')}
          onNeedsProfile={() => setError('The staff portal needs your own @marakin.co.uk Google account. Or use your password.')}
          dividerText="or use your password"
        />

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <div className="input-with-icon">
              <Mail size={18} />
              <input
                id="email"
                type="email"
                placeholder="admin@marakin.co.uk"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-with-icon">
              <Lock size={18} />
              <PasswordInput
                id="password"
                className=""
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          {expired && !error && <div className="error-message" style={{ background: 'rgba(196,148,58,0.14)', color: '#C4943A' }}>Your session expired — please sign in again.</div>}
          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            disabled={isLoading}
            className="btn-primary"
            style={{ width: '100%' }}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="platform-login-footer">
          <p>Marakin Staff Only</p>
        </div>
      </div>
    </div>
  );
}
